import { render, staticRenderFns } from "./Informacion.vue?vue&type=template&id=52475dc7&scoped=true"
import script from "./Informacion.vue?vue&type=script&lang=js"
export * from "./Informacion.vue?vue&type=script&lang=js"
import style0 from "./Informacion.vue?vue&type=style&index=0&id=52475dc7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52475dc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52475dc7')) {
      api.createRecord('52475dc7', component.options)
    } else {
      api.reload('52475dc7', component.options)
    }
    module.hot.accept("./Informacion.vue?vue&type=template&id=52475dc7&scoped=true", function () {
      api.rerender('52475dc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/otro-documento/Informacion.vue"
export default component.exports